import React from 'react';
import {observer} from 'mobx-react';
import openDesktopBrowser from '../../openDesktopBrowser.js';
import {active_vm_frame} from '../../activeVM.js';
import {is_whitelabel} from '../../consts.js';
import {user_whitelabel_status, active_vm_is_camera_capable} from "../../userData";
import VoiceButton from '../VoiceButton';
import {openLayoutEditor, multimon_available, triggerGuacFullscreen} from '../../webconnect/multimon.js';
import {release_keyboard_lock, send_esc_to_vm, set_fullscreen_exit_handler} from '../../webconnect/keyboardLock.js';
import MultiMonitorIcon from '../MultiMonitorIcon';


const is_fullscreen = () =>
  document.fullscreenElement ||
  document.webkitFullscreenElement ||
  document.mozFullScreenElement;

const exit_fullscreen = () => {

  // Stop capturing browser-reserved keys before anything else, so we never
  // leave the lock held while windowed.
  release_keyboard_lock();

  window.$('body').removeClass('full-screen');
  window.$('body').removeClass('sub-menu-open');
  window.$('body').removeClass('menu-open')
  window.$('body').removeClass('list-open');
  window.$('body').trigger("full-screen-change");


  if(window.isElectron) {
    // we enter via the BrowserWindow API, not DOM fullscreen, so is_fullscreen()
    // never sees it here — just clear it (no-op if already windowed)
    window.api.set_fullscreen(false);
  } else {
    is_fullscreen() && document.exitFullscreen();
  }

  // Make this connection's secondary windows exit fullscreen too.
  triggerGuacFullscreen(false);


};


window.addEventListener('fullscreenchange', () => !is_fullscreen() && exit_fullscreen());


// Let the keyboard-lock exit gestures leave fullscreen through this same
// function, rather than dropping out of fullscreen and relying on the listener
// above to tidy up after them.
set_fullscreen_exit_handler(exit_fullscreen);


// keep the menu within its offset parent (the visible screen)
const clampToBounds = (elmnt) => {
  if (!elmnt) return;

  const parent = elmnt.offsetParent || document.documentElement;
  const maxLeft = Math.max(0, parent.clientWidth - elmnt.offsetWidth);
  const maxTop = Math.max(0, parent.clientHeight - elmnt.offsetHeight);

  const newLeft = Math.max(0, Math.min(elmnt.offsetLeft, maxLeft));
  const newTop = Math.max(0, Math.min(elmnt.offsetTop, maxTop));

  elmnt.style.left = newLeft + "px";
  elmnt.style.top = newTop + "px";
};


class FullscreenWrapper extends React.Component {

  componentDidMount() {

    const i = document.getElementById("mydiv");

    // delegated so buttons added later (e.g. Monitors) also get a tooltip
    window.$(i).tooltip({ selector: 'button[title]' });

    dragElement(i);

    // re-clamp on resize so the menu doesn't end up off-screen
    this.handleResize = () => clampToBounds(i);
    window.addEventListener('resize', this.handleResize);



    function dragElement(elmnt) {


      const trigger = window.$(elmnt).find('.the-full-screen-trigger-menu');

      // click regisers only if not dragged
      trigger[0].onmouseup = () => {

        // if cursor as moved more than this number of pixels, the click is a drag
        const threshold = 8;

        if(Math.sqrt(Math.pow(start_x - pos3, 2) + Math.pow(start_y - pos4, 2)) < threshold) {

          window.$('body').toggleClass('sub-menu-open')

          // toolbar just grew/shrank, re-clamp
          clampToBounds(elmnt);

        }

      };

      var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
      if (document.getElementById(elmnt.id + "header")) {
        // if present, the header is where you move the DIV from:
        document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
      } else {
        // otherwise, move the DIV from anywhere inside the DIV:
        elmnt.onmousedown = dragMouseDown;
      }

      let start_x, start_y;
      function dragMouseDown(e) {

        start_x = e.clientX;
        start_y = e.clientY;

        e = e || window.event;
        e.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;

        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
      }

      function elementDrag(e) {

        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // move, then pull back inside the visible area
        elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
        elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
        clampToBounds(elmnt);
      }

      function closeDragElement() {
        // stop moving when mouse button is released:
        document.onmouseup = null;
        document.onmousemove = null;
      }
    }


  }

  componentWillUnmount() {
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize);
    }
    release_keyboard_lock();
  }

  render() {

    return (
      <div className="the-main-content"  tabIndex="-1">
    		<div className="container-fluid">
          <div className="full-screen-wrapper-container">
             <div id="mydiv">
                <div id="mydivheader">
                   <div className="the-full-screen-trigger-menu" title="Draggable menu">
                      <span>
                        {(user_whitelabel_status.get() || is_whitelabel) ?
                            <span style={{
                              fontWeight: 'bold',
                              fontSize: '1.5em',
                              display: 'inline-block',
                              marginTop: '2px'
                            }}>
                              ?
                            </span>

                          :
                            <img className='tw-inline-flex' src="images/menu.png" alt=""/>
                        }
                      </span>
                   </div>
                </div>
                <ul>
                   <li>
                      <button type="button" className="btn control-buttons make-full-screen-window" title="Exit Full screen" onClick={exit_fullscreen}>
                      <i className="fa fa-arrows-alt" aria-hidden="true"></i>
                      </button>
                   </li>
                   <li>
                      <button type="button" className="btn control-buttons send-esc-key" title="Send Esc" onClick={() => send_esc_to_vm()}>
                      <span style={{color: '#00438b', fontWeight: 'bold', fontSize: '0.85em'}}>Esc</span>
                      </button>
                   </li>
                   { multimon_available.get() &&
                   <li>
                      <button type="button" className="btn control-buttons make-multi-monitor" title="Monitors" style={{padding: '4px 8px'}} onClick={() => openLayoutEditor()}>
                      <MultiMonitorIcon color="#00438b" style={{height: '1.3em', width: '1.3em', display: 'inline-block'}} />
                      </button>
                   </li>
                   }
                   { !window.isRPi && !user_whitelabel_status.get() && !is_whitelabel &&
                   <li>
                      <button type="button" className="btn control-buttons" title={window.isElectron ? "Open in Browser" : "Open in Desktop"} onClick={openDesktopBrowser}>
                      <i style={{color: '#00438b', padding: 0}} className={window.isElectron ? "fa fa-window-maximize" : "fa fa-desktop"} aria-hidden="true"></i>
                      </button>
                   </li>
                   }

                   { active_vm_is_camera_capable() &&
                   <li>
                      <button type="button" className="btn control-buttons" title="Cameras" onClick={() => {
                        const iframe = active_vm_frame.get();
                        if (!iframe) return;
                        // Toggle the webconnect extension's camera menu via postMessage
                        iframe.contentWindow.postMessage({ type: 'v2cToggleCameraPopup' }, '*');
                      }}>
                      <i className="fa fa-video-camera" aria-hidden="true"></i>
                      </button>
                   </li>
                   }

                   <li>
                      <button type="button" className="btn control-buttons" data-toggle="modal" data-target="#share-screen-popup" title="Share screen">
                      <i className="fa fa-share-alt" aria-hidden="true"></i>
                      </button>
                   </li>

                   <li><VoiceButton /></li>

                   { !is_whitelabel && !user_whitelabel_status.get() &&
                     <>
                   <li>
                      <button type="button" className="btn control-buttons" title="Tutorials" data-toggle="modal" onClick={() => {
                        window.isElectron ? window.api.open_link_external("https://v2cloud.com/tutorials") : window.open("https://v2cloud.com/tutorials", '_blank').focus()
                      }}>
                      <i className="fa fa-book" aria-hidden="true"></i>
                      </button>
                   </li>

                   <li>
                      <button type="button" className="btn control-buttons" title="Live Help" onClick={() => {
                        // since this isn't mounted on intercom initialization, we click the other live help button which already
                        // has the proper observer
                        window.$('.live-help-button').click();
                      }}>
                      <i className="fa fa-user" style={{color:"#00438b"}} aria-hidden="true"></i>
                      </button>
                   </li>
                   </>

                 }
                </ul>
             </div>
          </div>

          {this.props.children}

        </div>
      </div>
    )

  }

}
export default observer(FullscreenWrapper)
